module.exports = __webpack_public_path__ + "img/VSLogo.ef42e9de.png";